export const selectAssetEventsReport = (state: any) => {
  return state.getIn(['accounting', 'assetEventsReport', 'assetEvents'])
}

export const selectSummaryFixedAssetEvents = (state: any) => {
  return state.getIn(['accounting', 'assetEventsReport', 'summary'])
}
